import React, { useState, useEffect, useCallback } from 'react';
import './StatusTab.css';
import './HealthHourTab.css';
import { MetricCard } from './HealthCards';

function SleepTab({ svc }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true); setError(null);
    try {
      const d = await svc.getHealthAll();
      if (d.error) throw new Error(d.error);
      setData(d);
    } catch (e) { setError(e.message); } finally { setLoading(false); }
  }, [svc]);

  useEffect(() => { load(); }, [load]);

  if (loading && !data) return <div className="st-view"><p className="st-msg">Carregando sono…</p></div>;

  return (
    <div className="st-view">
      <div className="st-head">
        <span className="st-updated">{data?.sono_ultima_atualizacao ? `Última atualização · ${data.sono_ultima_atualizacao}` : ''}</span>
        <button className="analise-refresh" onClick={load} disabled={loading}>{loading ? '…' : 'Atualizar'}</button>
      </div>
      {error && <p className="st-msg st-err">{error}</p>}

      {data?.sleep?.length > 0 ? (
        <div className="st-card">
          <h3 className="st-title">😴 Informações de Sono</h3>
          <div className="hh-grid">
            {data.sleep.map((m) => <MetricCard key={m.key} m={m} />)}
          </div>
        </div>
      ) : (
        !loading && <p className="st-msg">Sem dados de sono ainda.</p>
      )}

      <div className="st-spacer" />
    </div>
  );
}

export default SleepTab;
